// extracted by mini-css-extract-plugin
export default {"muneBtn":"style_muneBtn__e1e3n","text":"style_text__RFbC2"};